import React from 'react';
import Button from '@/components/ui/Button';
import { Calendar, MapPin, Building2, DollarSign, Clock, Eye, Filter, Search, X, ChevronDown, TrendingUp, Briefcase, CheckCircle, Send } from 'lucide-react';

const StatsSection = ({ 
stats 
}) => {


return (
<div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
<div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
<div className="flex items-center justify-between">
<div>
<p className="text-sm text-gray-600 mb-1">Total Applications</p>
<p className="text-3xl font-bold text-gray-900">{stats.total}</p>
</div>
<div className="bg-blue-100 p-3 rounded-full">
<Briefcase className="w-6 h-6 text-blue-600" />
</div>
</div>
</div>

<div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
<div className="flex items-center justify-between">
<div>
<p className="text-sm text-gray-600 mb-1">Applied Today</p>
<p className="text-3xl font-bold text-gray-900">{stats.appliedToday}</p>
</div>
<div className="bg-green-100 p-3 rounded-full">
<Send className="w-6 h-6 text-green-600" />
</div>
</div>
</div>

<div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
<div className="flex items-center justify-between">
<div>
<p className="text-sm text-gray-600 mb-1">Shortlisted</p>
<p className="text-3xl font-bold text-gray-900">{stats.shortlisted}</p>
</div>
<div className="bg-purple-100 p-3 rounded-full">
<CheckCircle className="w-6 h-6 text-purple-600" />
</div>
</div>
</div>
</div>
);
};

export default StatsSection;